import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("foreignObject", {
			x: -4,
			y: -4,
			width: 40,
			height: 40,
			children: /* @__PURE__ */ _jsx("div", {
				xmlns: "http://www.w3.org/1999/xhtml",
				style: {
					clipPath: "url(#bgblur_0_14969_159521_clip_path)",
					height: "100%",
					width: "100%"
				}
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			"data-figma-bg-blur-radius": 4,
			width: 32,
			height: 32,
			rx: 10,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 9.98047C21.67 9.65047 18.32 9.48047 14.98 9.48047C13 9.48047 11.02 9.58047 9.04 9.78047L7 9.98047",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 8.97L12.72 7.66C12.88 6.71 13 6 14.69 6H17.31C19 6 19.13 6.75 19.28 7.67L19.5 8.97",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8504 13.1406L22.2004 23.2106C22.0904 24.7806 22.0004 26.0006 19.2104 26.0006H12.7904C10.0004 26.0006 9.91039 24.7806 9.80039 23.2106L9.15039 13.1406",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3301 20.5H17.6601",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 16.5H18.5",
			stroke: "#6A4BC0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "bgblur_0_14969_159521_clip_path",
			transform: "translate(4 4)",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 32,
				rx: 10
			})
		}) })
	]
});
export default SvgDeleteIcon;
